export enum ContactChannelOptionType {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Telegram = 'TELEGRAM',
  Whatsapp = 'WHATSAPP',
  Other = 'OTHER',
}
